import Icon from './Icon.jsx';
import s from './EmptyState.module.css';

export default function EmptyState({ icon = 'flame', title, body, action }) {
  return (
    <div className={s.empty}>
      <span className={s.icon}><Icon name={icon} size="lg" /></span>
      {title && <span className={s.title}>{title}</span>}
      {body && <span className={s.body}>{body}</span>}
      {action}
    </div>
  );
}
